export * from './providers';

export type TODO = any;

export type ValueOf<T> = T[keyof T];

export interface Category {
  type: string;
  subtype: string;
  subtypeDisplayName: string;
  detailType: string;
  detailTypeDisplayName: string;
  detailTypeDescription?: string;
  id: string;
}

export interface Connection {
  id: string;
  integrationId: string;
  sourceId: string;
  platformName: string;
  linkUrl: string;
  status: string;
  lastSync: string;
  created: string;
  sourceType: string;
}

export enum AccountStep {
  ChooseProvider = 1,
  ConnectAddress = 2,
  AssignAccountNames = 3,
}

// NOTE: this is referred to as `TxnLabel` on the BE
export enum TransactionType {
  // grouping (eventually move to TxnGroupLabel)
  Bridge = 'Bridge',
  Exchange = 'Exchange',
  InternalTransfer = 'Internal Transfer',
  Transfer = 'Transfer',
  // in
  Purchase = 'Purchase',
  Deposit = 'Deposit',
  BridgeIn = 'Bridge In',
  Airdrop = 'Airdrop',
  Mint = 'Mint',
  Royalty = 'Royalty', // not used yet
  TransferIn = 'Transfer In',
  Buy = 'Buy',
  Unstake = 'Unstake',
  StakeIn = 'Stake In',
  UnstakeIn = 'Unstake In',
  Reward = 'Reward',
  RewardAccrued = 'Reward (accrued)',
  InternalLoanRepayment = 'Internal Loan Repayment',
  // out
  Sale = 'Sale',
  Withdrawal = 'Withdrawal',
  BridgeOut = 'Bridge Out',
  Fee = 'Fee',
  Burn = 'Burn', // not used yet
  TransferOut = 'Transfer Out',
  Sell = 'Sell',
  Stake = 'Stake',
  StakeOut = 'Stake Out',
  UnstakeOut = 'Unstake Out',
  InternalLoan = 'Internal Loan',
}

export const TransferTransactionTypes: TransactionType[] = [
  TransactionType.Transfer,
  TransactionType.TransferIn,
  TransactionType.TransferOut,
  TransactionType.BridgeIn,
  TransactionType.BridgeOut,
];

export const ExchangeTransactionTypes: TransactionType[] = [
  TransactionType.Exchange,
  TransactionType.Buy,
  TransactionType.Sell,
];

export const StakingInOutTransactionTypes: TransactionType[] = [
  TransactionType.Stake,
  TransactionType.StakeIn,
  TransactionType.StakeOut,
  TransactionType.Unstake,
  TransactionType.UnstakeIn,
  TransactionType.UnstakeOut,
];
